{
  "accountActions": {
    "error": "An error occurred."
  },
  "aiDetectionLlmPayload": {
    "text": "Detection target: {{goal}}",
    "text2": "Detection condition: {{condition}}"
  },
  "aiDetectionObservationsQuery": {
    "error": "The AI detection observation {{field}} is invalid.",
    "error2": "The AI detection observation isn't an object.",
    "error3": "The AI detection observation is missing required fields.",
    "error4": "The AI detection observation observedAt is invalid.",
    "error5": "The AI detection observation tenantCameraId is invalid.",
    "error6": "The AI detection observation validation is invalid.",
    "error7": "The accepted AI detection observation has a rejection reason.",
    "error8": "The rejected AI detection observation has no reason.",
    "error9": "The AI detection observation confidence is out of range.",
    "error10": "The AI detection observation validation and value are inconsistent.",
    "error11": "The AI detection observation unit is invalid.",
    "error12": "The AI detection observation period can be up to 24 hours.",
    "error13": "The AI detection observation limit is invalid.",
    "error14": "The AI detection observation sort order is invalid.",
    "error15": "The AI detection observation cursor is invalid.",
    "error16": "The AI detection observation response is invalid.",
    "error17": "The AI detection observation response nextCursor is invalid.",
    "error18": "Scanning AI detection observations was stopped.",
    "error19": "The AI detection observation page cursor was duplicated."
  },
  "aiDetectionReviews": {
    "error": "The AI detection review response is invalid.",
    "text": "The review conflicted with another change."
  },
  "aiDetectionsQuery": {
    "text": "People: {{value}}",
    "text2": "Value: {{value}}{{unit}}",
    "text3": "Value: {{value}}",
    "text4": "People: {{personCount}}",
    "error": "Scanning AI detection events was stopped.",
    "error2": "The AI detection event page cursor was duplicated."
  },
  "cameraMutations": {
    "text": "The area move was canceled because the AI detection status couldn't be checked.",
    "error": "AI detection is active. Stop AI detection before moving the camera to another area."
  },
  "recorderSubsystem": {
    "error": "The preset list couldn't be parsed."
  },
  "samlMutation": {
    "text": "SAML setup isn't complete. Contact your global administrator.",
    "error": "No tenant name is specified.",
    "error2": "The SAML response format is invalid."
  },
  "tenantSamlMutation": {
    "text": "A validation error occurred.",
    "error": "The tenant settings response format is invalid.",
    "error2": "The response doesn't include tenantConfiguration."
  },
  "thumbnailsQuery": {
    "error": "tenantId and cameraId are required."
  },
  "userMultipleInviteMutation": {
    "text": "Sending failed."
  },
  "login": {
    "text": "Use 8–256 characters, including uppercase letters, lowercase letters, numbers, and symbols.",
    "text3": "The email address or password is incorrect. Enter them again.",
    "text6": "An error occurred while signing in: {{value}}",
    "error": "A new password is required.",
    "text7": "An error occurred while setting the new password: {{value}}",
    "expired": "The sign-in session has expired. Sign in again."
  },
  "mfa": {
    "message": "The verification code limit has been reached. Wait a while, then sign in again.",
    "message3": "An error occurred."
  },
  "passwordPolicy": {
    "passwordPolicyError": "Use 8–256 characters, including uppercase letters, lowercase letters, numbers, and symbols."
  },
  "useNotFoundRedirect": {
    "enqueueSnackbar": "This page doesn't exist."
  },
  "accountMenu": {
    "text": "Help center",
    "ariaLabel": "Open account menu",
    "title": "Account settings",
    "title2": "Company settings",
    "menuItem": "Privacy policy",
    "menuItem2": "Terms of service",
    "text2": "Official app",
    "menuItem3": "Sign out",
    "language": "Language"
  },
  "calendarDateTimePicker": {
    "text": "Sun",
    "text2": "Mon",
    "text3": "Tue",
    "text4": "Wed",
    "text5": "Thu",
    "text6": "Fri",
    "text7": "Sat",
    "ariaLabel": "Previous day",
    "ariaLabel2": "Select date and time: {{displayDateTime}}",
    "ariaLabel3": "Next day",
    "ariaLabel4": "Time",
    "ariaLabel5": "Go to selected date and time",
    "ariaLabel6": "Set to current time",
    "text8": "Now"
  },
  "row": {
    "text": "Collapse",
    "text2": "Expand"
  },
  "dialog": {
    "ariaLabel": "Close dialog"
  },
  "documentLayout": {
    "link": "Sign in",
    "link2": "Help center",
    "link3": "Terms of service",
    "link4": "Privacy policy",
    "link5": "About us"
  },
  "emailListInput": {
    "text": "Email address",
    "text2": "Add",
    "text3": "Remove email address field"
  },
  "header": {
    "text": "Live view"
  },
  "imagePreviewDialog": {
    "text": "Downloading...",
    "text2": "Download",
    "text3": "The image couldn't be displayed.",
    "text4": "The download failed."
  },
  "search": {
    "text": "Search by camera, area, or tag"
  },
  "multiSelect": {
    "text": "Text",
    "text2": "{{length}} selected"
  },
  "nestedMultiSelect": {
    "text": "Area and device view permissions",
    "text2": "{{length}} selected"
  },
  "select": {
    "text": "Text"
  },
  "sidebar": {
    "label": "Live view",
    "label2": "Captures",
    "label3": "User management",
    "label4": "Camera management",
    "label5": "Area management",
    "label6": "Tag management",
    "label7": "Licenses",
    "label8": "Patlite management",
    "label9": "Firmware management",
    "label10": "Map management",
    "replace": "\nmanagement"
  },
  "simplePagination": {
    "text": "{{value}}+ items",
    "text2": "{{value}} items",
    "text3": "{{value}}-{{value2}} of {{value3}}+",
    "text4": "{{value}}-{{value2}} of {{value3}}"
  },
  "assertNever": {
    "error": "{{context}}: Unsupported value {{value}}"
  },
  "emailValidation": {
    "emailValidationMessage": "Enter a valid email address."
  },
  "tenant": {
    "label": "User manual",
    "label2": "Help center"
  },
  "aiDetectionCsvExportLimit": {
    "error": "CSV export was stopped.",
    "error2": "The CSV export scan limit was reached. Shorten the period and try again. No CSV was exported.",
    "error3": "The CSV export limit ({{value}} rows) was exceeded. Change the period or filters. No CSV was exported."
  },
  "meterReadingResults": {
    "text": "Reading rejected",
    "error": "The meter history cursor is invalid."
  },
  "useMeterReadingPreviews": {
    "error": "The tenant couldn't be identified.",
    "text": "Readings can't be retrieved",
    "text2": "Loading readings",
    "text3": "No readings in the last 24 hours. Set a period in the details."
  },
  "detectionConditionField": {
    "label": "Detection condition"
  }
}
